// extracted by mini-css-extract-plugin
export var arrowImage = "index-module--arrow-image--JFMei";
export var tryItButton = "index-module--try-it-button--PTb29";
export var tryItButtonNotice = "index-module--try-it-button-notice--+2Kjj";
export var tryItButtonWrapper = "index-module--try-it-button-wrapper--lY0Bc";
export var wrapper = "index-module--wrapper--SFvfr";